import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Bold02 = function Bold02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M6 4v16M9.5 4h6c2.2091 0 4 1.7909 4 4s-1.7909 4-4 4h-6 7c2.2091 0 4 1.7909 4 4s-1.7909 4-4 4h-7m0-16v16m0-16H4m5.5 16H4"
    })
  }));
};
export default Bold02;